<script setup lang="ts">
import PasswordChangeRequestSuccessFeedback from './components/password-change-request-success-feedback.component.vue';
import { ref } from 'vue';
import { route } from 'ziggy-js';
import { useForm } from '@inertiajs/vue3';
import { FormOverlay, InputError, SGButton, SGInputText } from '@/Components/Form';
import AuthLayout from '@/Layouts/AuthLayout.vue';
import { IconArrowLeft, IconEmail, IconErrorWarning } from '@/assets/icons/index';

const form = useForm({
	email: '',
});

const isPasswordChangeRequestSent = ref(false);

const submit = () => {
	form.post(route('password.email'), {
		onSuccess: () => {
			isPasswordChangeRequestSent.value = true;
		},
	});
};
</script>

<template>
	<AuthLayout :title="$t('Forgot Password')" :seo="false">
		<div class="dark:text-white w-full md:w-[400px] lg:w-[500px] h-full">
			<div class="w-full h-full flex flex-col justify-center relative">
				<template v-if="!isPasswordChangeRequestSent">
					<div class="mb-14">
						<h1 class="text-primary text-j44-medium mb-4">
							{{ $t('Forgot your password?') }}
						</h1>
						<span class="text-sg-dark-grape-100 text-j18-regular">{{
							$t(
								'Enter the email address you used when you joined and we’ll send you instructions to reset your password.',
							)
						}}</span>
					</div>

					<!--                <div v-if="$page.props?.status" class="mb-4 font-medium text-sm text-green-600 dark:text-green-400">
                        {{ $page.props?.status }}
                    </div>-->
					<FormOverlay :form="form" has-custom-submit-button @submitted="submit">
						<SGInputText
							id="email"
							v-model="form.email"
							type="email"
							placeholder="Email"
							placeholder-style="floating"
							required
							hide-required
							autofocus
							name="email"
							:icon="IconEmail"
							autocomplete="username"
							class="block w-full"
							:has-error="!!form.errors.email"
						/>

						<div v-if="form.errors.email" class="flex items-center space-x-2 mt-2">
							<IconErrorWarning class="w-5 h-5 mt-2" />
							<InputError class="mt-2" :message="form.errors.email" />
						</div>
						<SGButton is-cta class="w-full mt-10" type="submit" :disabled="form.processing">
							{{ $t('Send request') }}
						</SGButton>
					</FormOverlay>

					<div class="flex items-center justify-center my-6">
						<div class="flex-grow border-t border-grey-grape-200"></div>
						<span class="mx-5 text-gray-500">or</span>
						<div class="flex-grow border-t border-grey-grape-200"></div>
					</div>
					<SGButton
						:icon="IconArrowLeft"
						color="white"
						icon-direction="left"
						class="w-full"
						as="a"
						:href="route('login')"
					>
						{{ $t('Back to Sign in') }}
					</SGButton>
				</template>
				<PasswordChangeRequestSuccessFeedback v-else :user-email="form.email" />
			</div>
		</div>
	</AuthLayout>
</template>
